import { IkasVariantType, IkasVariantTypeTranslation } from ".";
import { initIkasVariantValue } from "./variant-value/init";

export function initIkasVariantType(
  variantType: IkasVariantType,
  locale: string | null
) {
  variantType.values.forEach((v) => {
    v.variantTypeId = variantType.id;
    initIkasVariantValue(v);
  });

  if (variantType.translations && locale) {
    setTranslations(variantType, variantType.translations, locale);
    delete variantType.translations;
  }
}

function setTranslations(
  variantType: IkasVariantType,
  translations: IkasVariantTypeTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name) variantType.name = localeTranslations.name;
    if (localeTranslations?.values) {
      variantType.values.forEach((vv) => {
        const translatedVV = localeTranslations.values?.find(
          (tvv) => tvv.id === vv.id
        );
        if (translatedVV && translatedVV.name) vv.name = translatedVV.name;
      });
    }
  }
}
